const WhyChooseUs = () => {
  const features = [
    {
      icon: "🧠",
      title: "Voice Command Automation",
      description: "Control your CRM by voice. Schedule appointments, send follow-ups, and manage customer data hands-free with AI-powered voice agents."
    },
    {
      icon: "🤖",
      title: "AI Robotics & Integration",
      description: "Seamless deployment for cleaning, delivery, and scheduling robots. Complete installation, training, and support included."
    },
    {
      icon: "📊",
      title: "Data-Driven Results",
      description: "Track ROI and performance in real-time. Monitor labor savings, customer satisfaction, and efficiency metrics from one dashboard."
    }
  ];

  return (
    <section className="py-16">
      <div className="text-center mb-12">
        <h2 className="font-orbitron font-bold text-4xl md:text-5xl mb-4">
          Why Choose <span className="text-primary">Neil AI Global Solutions</span>?
        </h2>
        <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
          We're not just a vendor — we're your partner in automation success.
        </p>
      </div>

      <div className="grid md:grid-cols-3 gap-8 mb-8">
        {features.map((feature) => (
          <div
            key={feature.title}
            className="text-center p-8 border border-[hsl(var(--line))] rounded-2xl glass-effect hover:border-primary/40 transition-all duration-300 group"
          >
            <div className="text-6xl mb-6 group-hover:scale-110 transition-transform duration-300">{feature.icon}</div>
            <h3 className="font-orbitron font-bold text-xl mb-3 text-foreground">{feature.title}</h3>
            <p className="text-muted-foreground leading-relaxed">{feature.description}</p>
          </div>
        ))}
      </div>

      <div className="text-center mt-8 pt-8 border-t border-[hsl(var(--line))]">
        <p className="text-lg text-muted-foreground max-w-4xl mx-auto leading-relaxed">
          <span className="font-bold text-primary">100+ businesses served</span> across the Southeast | 
          <span className="font-bold text-primary"> Authorized PUDU Dealer</span> | 
          <span className="font-bold text-primary"> AI-First Business Growth Partner</span>
        </p>
      </div>
    </section>
  );
};

export default WhyChooseUs;
